import apiUtils from "./apiUtils";

const fetchProductById = async (id) => {
    return apiUtils.get(
        `/api/products/${id}`, 
        'Не удалось получить информацию о товаре'
    );
};

const quickSearchProducts = async (query) => {
    return apiUtils.get(
        `/api/products/quick-search?q=${encodeURIComponent(query)}`,
        'Не удалось выполнить поиск продуктов'
    );
};

const fetchProductList = async (queryString) => {
    return apiUtils.get(
        `/api/products?${queryString}`,
        'Не удалось получить список товаров'
    );
};

const getPriceRange = async (params = {}) => {
    let queryString = '';
    if (Object.keys(params).length > 0) {
        queryString = '?' + new URLSearchParams(params).toString();
    }
    return apiUtils.get(
        `/api/products/price-range${queryString}`,
        'Не удалось получить диапазон цен'
    );
};

const deleteProduct = async (productId) => {
    return apiUtils.delete(
        `/api/products/${productId}`,
        'Ошибка при удалении товара'
    );
};

const updateProduct = async (productId, productData) => {
    return apiUtils.put(
        `/api/products/${productId}`,
        productData,
        'Ошибка при обновлении товара',
        true
    );
};

const createProduct = async (productData) => {
    return apiUtils.post(
        `/api/products`,
        productData,
        'Ошибка при создании товара',
        true
    );
};

const duplicateProduct = async (productId) => {
    return apiUtils.post(
        `/api/products/${productId}/copy`,
        null,
        'Ошибка при дублировании товара',
        true
    );
};

const updateProductsOrder = async (orderUpdates) => {
    return apiUtils.put(
        `/api/products/update-order`,
        orderUpdates,
        'Ошибка при обновлении порядка товаров'
    );
};

export default { 
    fetchProductById, 
    quickSearchProducts, 
    fetchProductList, 
    getPriceRange, 
    deleteProduct, 
    updateProduct, 
    createProduct, 
    duplicateProduct, 
    updateProductsOrder
};